import { TableCell } from "@mui/material";
import { formatDate } from "../../../../../utils/dateUtils";
import { ServiceProvided } from "../../types";

type DatesTableCellsProps = {
	serviceProvided: ServiceProvided;
};

export const DatesTableCells = ({ serviceProvided }: DatesTableCellsProps) => {
	const actualDateEndDisplay = serviceProvided.date_end ? formatDate(serviceProvided.date_end) : null

	return (
		<>
			<TableCell align="center">{formatDate(serviceProvided.date_begin)}</TableCell>
			<TableCell align="center">{actualDateEndDisplay}</TableCell>
		</>
	);
};